import { render } from "./BillDiscountApplicationList.vue?vue&type=template&id=ffb4e07c&scoped=true"
import script from "./BillDiscountApplicationList.vue?vue&type=script&lang=js"
export * from "./BillDiscountApplicationList.vue?vue&type=script&lang=js"

import "./BillDiscountApplicationList.vue?vue&type=style&index=0&id=ffb4e07c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb4e07c"]])

export default __exports__